(() => {
  const CONFIG = {
    companyId: 'WgVq6h',
    listId: 'WGCbaC'
  };

  const path = window.location.pathname.replace(/\/$/, '');
  if (path !== '/pages/warranty-registration') return;
  const hidePreviewBar = () => {
    const bar = document.getElementById('PBarNextFrameWrapper');
    if (bar) {
      bar.style.display = 'none';
      bar.setAttribute('aria-hidden', 'true');
    }
  };
  hidePreviewBar();
  setTimeout(hidePreviewBar, 500);
  setTimeout(hidePreviewBar, 1500);
  if (document.querySelector('[data-nl-warranty-registration]')) return;

  const css = `
    .nl-warranty { --teal:#3fd0c8; --teal-dark:#0f766e; --ink:#102221; --muted:#5f6f6d; --line:#dcefed; --bg:#f4fbfa; font-family: inherit; }
    .nl-warranty * { box-sizing:border-box; }
    .nl-warranty { width:min(1120px, calc(100% - 32px)); margin: 12px auto 58px; }
    .nl-warranty__hero { background:linear-gradient(135deg,#f5fffe 0%,#ffffff 58%,#e6fbf8 100%); border:1px solid var(--line); border-radius:30px; padding:clamp(28px,5vw,58px); box-shadow:0 24px 70px rgba(15,118,110,.10); }
    .nl-warranty__eyebrow { color:var(--teal-dark); text-transform:uppercase; letter-spacing:.14em; font-size:12px; font-weight:900; margin:0 0 12px; }
    .nl-warranty h2 { margin:0; color:var(--ink); font-size:clamp(32px,5vw,58px); line-height:1.02; letter-spacing:-.04em; }
    .nl-warranty__lead { max-width:760px; color:var(--muted); font-size:clamp(16px,2vw,19px); line-height:1.65; margin:18px 0 0; }
    .nl-warranty__grid { display:grid; grid-template-columns:minmax(0,1.2fr) minmax(280px,.8fr); gap:22px; align-items:start; margin-top:24px; }
    .nl-warranty__form, .nl-warranty__aside { background:#fff; border:1px solid var(--line); border-radius:24px; padding:24px; box-shadow:0 14px 40px rgba(16,34,33,.06); }
    .nl-warranty__form { display:grid; gap:16px; }
    .nl-warranty__row { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
    .nl-warranty label { display:grid; gap:7px; color:var(--ink); font-weight:800; font-size:14px; }
    .nl-warranty small { color:var(--muted); font-weight:500; line-height:1.45; }
    .nl-warranty input, .nl-warranty select, .nl-warranty textarea { width:100%; border:1px solid #cde5e2; border-radius:16px; padding:14px 15px; min-height:50px; font:inherit; color:var(--ink); background:#fbfffe; }
    .nl-warranty textarea { min-height:108px; resize:vertical; }
    .nl-warranty input:focus, .nl-warranty select:focus, .nl-warranty textarea:focus { outline:none; border-color:var(--teal-dark); box-shadow:0 0 0 4px rgba(63,208,200,.18); }
    .nl-warranty__check { display:flex !important; grid-template-columns:none !important; gap:10px !important; align-items:flex-start; font-weight:650 !important; color:var(--muted) !important; line-height:1.45; }
    .nl-warranty__check input { width:18px; height:18px; min-height:18px; margin-top:3px; flex:0 0 auto; accent-color:var(--teal-dark); }
    .nl-warranty__submit { border:0; border-radius:999px; min-height:54px; padding:0 26px; background:var(--teal); color:#082f2c; font-weight:950; cursor:pointer; box-shadow:0 16px 30px rgba(63,208,200,.24); letter-spacing:.02em; }
    .nl-warranty__submit[disabled] { opacity:.62; cursor:wait; }
    .nl-warranty__status { display:none; padding:14px 16px; border-radius:16px; font-weight:750; line-height:1.45; }
    .nl-warranty__status.is-ok { display:block; background:#e8fbf7; color:#0f766e; border:1px solid #afe9df; }
    .nl-warranty__status.is-error { display:block; background:#fff2f2; color:#9b1c1c; border:1px solid #ffc9c9; }
    .nl-warranty__aside h3 { margin:0 0 10px; font-size:20px; color:var(--ink); }
    .nl-warranty__aside p, .nl-warranty__aside li { color:var(--muted); line-height:1.58; }
    .nl-warranty__aside ul { padding-left:18px; margin:12px 0 0; }
    @media (max-width: 780px) { .nl-warranty { width:min(100% - 20px, 1120px); } .nl-warranty__hero { padding:24px 18px; border-radius:22px; } .nl-warranty__grid, .nl-warranty__row { grid-template-columns:1fr; } .nl-warranty__form, .nl-warranty__aside { padding:18px; border-radius:20px; } }
  `;

  const style = document.createElement('style');
  style.id = 'nl-warranty-registration-style';
  style.textContent = css;
  document.head.appendChild(style);

  const mount = document.createElement('section');
  mount.className = 'nl-warranty';
  mount.setAttribute('data-nl-warranty-registration', '');
  mount.innerHTML = `
    <div class="nl-warranty__hero">
      <p class="nl-warranty__eyebrow">Nuovaluce warranty registration</p>
      <h2>Register your Nuovaluce device.</h2>
      <p class="nl-warranty__lead">Submit your product and purchase details so our support team can identify your device if you ever need warranty help. Warranty coverage is governed by the current Nuovaluce warranty policy.</p>
      <div class="nl-warranty__grid">
        <form class="nl-warranty__form" novalidate>
          <div class="nl-warranty__status" role="status" aria-live="polite"></div>
          <div class="nl-warranty__row">
            <label>First name<input name="first_name" autocomplete="given-name" required></label>
            <label>Last name<input name="last_name" autocomplete="family-name" required></label>
          </div>
          <label>Email address<input name="email" type="email" inputmode="email" autocomplete="email" required></label>
          <div class="nl-warranty__row">
            <label>Order number<input name="order_number" autocomplete="off" placeholder="Example: #1234" required></label>
            <label>Purchase date<input name="purchase_date" type="date" required></label>
          </div>
          <label>Product<select name="product" required>
            <option value="">Select product</option>
            <option>Nuovaluce Anti Aging Max Device</option>
            <option>Nuovaluce LED Light Therapy Face Mask</option>
            <option>Nuovaluce Microcurrent Device</option>
            <option>Nuovaluce Mini Device</option>
            <option>Other Nuovaluce product</option>
          </select></label>
          <label>Serial number <small>If your product has one, enter it here.</small><input name="serial_number" autocomplete="off" placeholder="Optional"></label>
          <label>Notes <small>Optional: tell us anything helpful about the purchase or product.</small><textarea name="notes" placeholder="Optional"></textarea></label>
          <label class="nl-warranty__check"><input name="consent" type="checkbox" required><span>I agree Nuovaluce may email me about this warranty registration and product-support updates.</span></label>
          <button class="nl-warranty__submit" type="submit">Submit warranty registration</button>
        </form>
        <aside class="nl-warranty__aside" aria-label="Warranty registration help">
          <h3>Before you submit</h3>
          <p>Use the email and order number from your Nuovaluce purchase so support can match the registration quickly.</p>
          <ul>
            <li>No password or payment information is needed.</li>
            <li>Keep your order confirmation for your records.</li>
            <li>Questions? Use the Contact Us link in the footer.</li>
          </ul>
        </aside>
      </div>
    </div>`;

  const main = document.querySelector('main');
  const pageTitle = document.querySelector('main h1');
  const pageTitleWrap = pageTitle?.parentElement;
  if (pageTitleWrap) {
    [...pageTitleWrap.children].forEach(child => {
      if (child === pageTitle || child.contains(pageTitle)) return;
      child.style.display = 'none';
      child.setAttribute('aria-hidden', 'true');
    });
  }
  if (main) {
    [...main.children].forEach(child => {
      if (child.contains(pageTitle) || child.hasAttribute('data-nl-warranty-registration')) return;
      child.style.display = 'none';
      child.setAttribute('aria-hidden', 'true');
    });
  }
  const target = pageTitleWrap || main || document.body;
  target.insertAdjacentElement('afterend', mount);

  const form = mount.querySelector('form');
  const status = mount.querySelector('.nl-warranty__status');
  const button = mount.querySelector('.nl-warranty__submit');

  function show(type, message) {
    status.className = `nl-warranty__status is-${type}`;
    status.textContent = message;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const data = Object.fromEntries(new FormData(form).entries());
    button.disabled = true;
    button.textContent = 'Submitting…';
    show('ok', 'Submitting your warranty registration…');

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email,
                first_name: data.first_name,
                last_name: data.last_name,
                properties: {
                  warranty_registration: true,
                  warranty_order_number: data.order_number,
                  warranty_purchase_date: data.purchase_date,
                  warranty_product: data.product,
                  warranty_serial_number: data.serial_number || '',
                  warranty_notes: data.notes || '',
                  warranty_source_url: window.location.href,
                  source: 'Nuovaluce warranty registration page'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: CONFIG.listId } } }
      }
    };

    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(CONFIG.companyId)}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          'revision': '2026-04-15'
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok && res.status !== 202) throw new Error(`Klaviyo returned ${res.status}`);
      form.reset();
      show('ok', 'Received — your warranty registration was submitted. Keep your order confirmation for your records.');
    } catch (err) {
      console.warn('[Nuovaluce warranty registration] submission failed', err);
      show('error', 'Something blocked the registration. Please check your details and try again, or contact support.');
    } finally {
      button.disabled = false;
      button.textContent = 'Submit warranty registration';
    }
  });
})();
